// Page counts for a scan result.
//
// results.table only lists pages where a keyword matched, so its length is
// "pages with matches", not "pages scanned". The number of pages actually
// crawled comes from debug_info.total_scanned_pages (or scanned_pages).
// That was mislabeled as "Pages Scanned" in the results summary and PDF.

// Pages the crawl actually visited, or null if this result doesn't say
// (e.g. a zero-match result, which doesn't carry the crawl stats).
export function pagesScanned(result) {
  if (!result) return null;
  if (typeof result.debug_info?.total_scanned_pages === "number") return result.debug_info.total_scanned_pages;
  if (Array.isArray(result.scanned_pages)) return result.scanned_pages.length;
  return null;
}

export function pagesWithMatches(result) {
  return result?.table?.length || 0;
}

// "42 (3 with matches)", or just "3 with matches" when the crawl size is unknown.
export function pagesSummary(result) {
  const scanned = pagesScanned(result);
  const matched = pagesWithMatches(result);
  if (scanned === null) return `${matched} with matches`;
  return scanned === matched ? `${scanned}` : `${scanned} (${matched} with matches)`;
}
